import api from "../api/axiosConfig";

const transactionService = {
  getSummary: (month) => api.get("/summary", { params: { month } }),
  getTotalSavings: () => api.get("/totalSavings"),
  // ahora acepta categoryId opcional como filtro
  getTransactions: (startDate, endDate, categoryId) =>
    api.get("/transactions", { params: { startDate, endDate, categoryId } }),
  createTransaction: (data) => api.post("/createTransaction", data),
  updateTransaction: (id, data) => api.put(`/updateTransaction/${id}`, data),
  deleteTransaction: (id) => api.delete(`/transactions/${id}`),

  // Transacciones recurrentes
  getRecurringTransactions: () => api.get("/recurringTransactions"),
  createRecurringTransaction: (data) =>
    api.post("/createRecurringTransaction", data),
  deleteRecurringTransaction: (id) =>
    api.delete(`/recurringTransactions/${id}`),
  processRecurringTransactions: () =>
    api.post("/processRecurringTransactions"),
};

export default transactionService;